import React, { Component } from 'react';
import { Button, Modal,Tab,Tabs,Row,Col, Form } from 'react-bootstrap';


import { ColorEdit } from './Premium/ColorEdit';
import { ImageEdit } from './Premium/ImageEdit';
import Swal from 'sweetalert2';
import TeamAccounts from './TeamAccounts';
export class TeamEditor extends Component {
    _isMounted = false;
    initialBranding = {   
         displayPoweredBy:true,
        headerColorCode: "",
        lastPaymentCheck: new Date(1901,1,1),
        paymentAccountNumber: "",
        paymentId: "",
        titleColorCode: "",
        mainLogo: "",
         mobileLogo: "",
        logoHrefURL:""
    }
    constructor(props) {
        super(props);
     
        this.onChangeDisplay = this.onChangeDisplay.bind(this);
        this.onChangeTeamName = this.onChangeTeamName.bind(this);
        this.onChangeLogoHrefURL = this.onChangeLogoHrefURL.bind(this);        
        this.onHeaderChangeComplete = this.onHeaderChangeComplete.bind(this);
        this.onTitleChangeComplete = this.onTitleChangeComplete.bind(this);
        this.saveSubmit = this.saveSubmit.bind(this);
        this.deleteSubmit = this.deleteSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onMainDrop = this.onMainDrop.bind(this);
        this.onMobileDrop = this.onMobileDrop.bind(this);
        this.onResetClick = this.onResetClick.bind(this);        
        const teamExists = !!this.props.team;
        const hasBranding = teamExists ? this.props.team.branding.premium : false;      
       
       
        if (hasBranding) {          
            this.initialBranding.paymentAccountNumber = this.props.team.branding.paymentAccountNumber;
            this.initialBranding.paymentId = this.props.team.branding.paymentId;
            this.initialBranding.lastPaymentCheck = this.props.team.branding.lastPaymentCheck;
            this.initialBranding.displayPoweredBy = this.props.team.branding.displayPoweredBy;
            this.initialBranding.headerColorCode = this.props.team.branding.headerColorCode;
            this.initialBranding.titleColorCode = this.props.team.branding.titleColorCode;
            this.initialBranding.mainLogo = this.props.team.branding.mainLogoURL;
            this.initialBranding.mobileLogo = this.props.team.branding.mobileLogoURL;
            this.initialBranding.logoHrefURL = this.props.team.branding.logoHrefURL;

        }
  
        this.state = {
            teamName: teamExists ? this.props.team.name : '', team: this.props.team, method: teamExists ? 'PUT' : 'POST',
            message: '', account: this.props.accNum, hasBranding: hasBranding, showModal: teamExists,            
            displayPoweredBy:this.initialBranding.displayPoweredBy,
            headerColorCode: this.initialBranding.headerColorCode,
            titleColorCode: this.initialBranding.titleColorCode,
            mainLogo: this.initialBranding.mainLogo,
            mobileLogo: this.initialBranding.mobileLogo,
            logoHrefURL: this.initialBranding.logoHrefURL
        }
    }


    componentDidMount() {
        this._isMounted = true;
  
        //if (!!this.state.team) {
        //    $('#teamModal').modal();        }
    
       
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    handleClose() {
        this.setState({ showModal: false });
        this.props.refresh();
    }    
    async saveSubmit(e) {
        e.preventDefault();

        var data = [];
        var existingTeam = !!this.state.team;
        if (existingTeam) {          
            
            data = JSON.parse(JSON.stringify(this.state.team));
         
            data.name = this.state.teamName;
            
            if (this.state.hasBranding) {
                data.branding = {             
                    PaymentAccountNumber: this.initialBranding.paymentAccountNumber,
                    PaymentId: this.initialBranding.paymentId,
                    lastPaymentCheck: this.initialBranding.lastPaymentCheck,                 
                    DisplayPoweredBy:this.state.displayPoweredBy,
                    MainLogoURL: this.state.mainLogo,
                    MobileLogoURL:this.state.mobileLogo,
                    HeaderColorCode: this.state.headerColorCode,
                    TitleColorCode: this.state.titleColorCode,                   
                    LogoHrefURL: this.state.logoHrefURL,
                    Premium:this.state.hasBranding
                }
            }
        }
        else {
            data = { ownerID: this.state.account, name: this.state.teamName }
           
        }

        const resp = await fetch('api/team/saveteam', {
            method: this.state.method,
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        var respData = await resp.json();
        if (resp.status === 200) {
            try {
                this.setState({ showModal: false });     
             
                if (existingTeam) {
                    this.props.saveSuccess();
                }
                else {                 
                    this.props.saveSuccess(respData.id);
                }

            } catch (e) {
                console.log(resp.respData);
                this.setState({ message: (<div className="text-danger card"> 500: Check console</div>) })
            }
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else if (resp.status === 400) {
            this.setState({ message: respData.statusText })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });
        }
    }

    deleteConfirm = async (e) => {
        e.preventDefault();
        Swal.fire({
            title: 'Delete',
            text: 'Are you sure you want to delete team '+this.state.teamName+'?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it.',
            cancelButtonText: 'No.'
        }).then(async (result) => {
            if (result.value) {
               await  this.deleteSubmit();
            } else if (result.dismiss === Swal.DismissReason.cancel) {

            }
        })
    }
    async deleteSubmit() {   
       
        const resp = await fetch('api/team/deleteteam?teamid=' + encodeURIComponent(this.state.team.id), {
            method: 'DELETE',
            credentials: 'same-origin'

        });
        if (resp.status === 200) {
            try {
                this.handleClose();
                this.props.saveSuccess(this.state.team.id, true);               

            } catch (e) {
                console.log(resp.statusText);
                this.setState({ message: '500: Check console' })
            }
           
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });
        }
    }
    onChangeTeamName(e) {
        this.setState({
            teamName: e.target.value
        });
    }
    //onChangeAllowIndex(e) {

    //    this.setState({
    //        allowIndex: e.target.checked
    //    });
    //    console.log(this.state.allowIndex);
    //}
    onChangeDisplay(e) {
     
         this.setState({
            displayPoweredBy: e.target.checked
        });
     
    }
    onChangeLogoHrefURL(e) {
        this.setState({
            logoHrefURL: e.target.value
        });
    }

    onHeaderChangeComplete(color) {
        this.setState({ headerColorCode: color.hex });
    }
    onTitleChangeComplete(color) {
        this.setState({ titleColorCode: color.hex });
    }
    onMainDrop(url) {     
        this.setState({ mainLogo: url });   
        
    }

    onMobileDrop(url) {
        this.setState({ mobileLogo: url });       
    }
    onResetClick(e) {
        e.preventDefault();
        this.setState({
            allowIndex:this.initialBranding.allowIndex,
            displayPoweredBy: this.initialBranding.displayPoweredBy,
            headerColorCode: this.initialBranding.headerColorCode,
            titleColorCode: this.initialBranding.titleColorCode,
            mainLogo: this.initialBranding.mainLogo,
            mobileLogo: this.initialBranding.mobileLogo,
            logoHrefURL: this.initialBranding.logoHrefURL })
    }
    

    render() {
        const msg = this.state.message;
        const headerStyle = { backgroundColor: this.state.headerColorCode, paddingTop:'5px',marginBottom:'5px'};
        const titleStyle = { color: this.state.titleColorCode };
        const bothStyle = { color: this.state.titleColorCode,  backgroundColor: this.state.headerColorCode, border: 0}
        const show = this.state.showModal;
        const premiumEdit = !!this.state.team? ( this.state.hasBranding ? (
            <Tab eventKey="Premium" title="Branding">
                <form className="form-horizontal m15">
                    <div className="form-group row">
                        <label htmlFor="LogoURL" className="col-sm-2">Logo Hyperlink</label>
                        <div className="col-sm-8">
                            <Form.Control type="text" className="form-control" name="LogoURL" id="LogoURL"
                                value={this.state.logoHrefURL} onChange={this.onChangeLogoHrefURL} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="offset-sm-2 col-sm-10">
                            <Form.Check type="switch" id="displayed"
                                label="display powered by gstitch"
                                defaultChecked={this.state.displayPoweredBy}
                                onChange={this.onChangeDisplay} />
                        </div>
                    </div>
                   
                </form>

                <div className="m15">
                    <Row style={headerStyle} id="exampleBar">
                        <Col >
                            <img className="" alt="" style={{ height: '40px', maxWidth: '250' }} src={this.state.mainLogo} />
                        </Col>
                        <Col>
                            <button className="" style={bothStyle}>&#9776;</button>
                        </Col>
                        <Col >
                            <h5 style={titleStyle}>Text Color</h5>
                        </Col>
                        <Col >
                            <img className="  " alt="" src={this.state.mobileLogo} style={{ height: '40px', maxWidth: '250' }} />
                        </Col>
                    </Row>
                    <div className="row"> 

                        <div className="col">
                            <Tabs defaultActiveKey="mainIcon">
                                <Tab eventKey="mainIcon" title="Logo">
                                    <ImageEdit name="Main" onDrop={this.onMainDrop} />
                                </Tab>

                                <Tab eventKey="headerColor" title="Background">
                                    <ColorEdit name="Header" colorCode={this.state.headerColorCode} onChangeComplete={this.onHeaderChangeComplete} />
                                </Tab>
                                <Tab eventKey="titleColor" title="Text">
                                    <ColorEdit name="Title" colorCode={this.state.titleColorCode} onChangeComplete={this.onTitleChangeComplete} />
                                </Tab>

                                <Tab eventKey="MobileIcon" title="Icon">
                                    <ImageEdit name="Mobile" onDrop={this.onMobileDrop} />
                                </Tab>

                            </Tabs>
                    </div>

                    
                    </div>


                    <div class="row mt20">
                        <div class="col-sm-12 m0">
                            <Button variant="danger" className="btn-sm float-sm-right" onClick={this.onResetClick}>Reset</Button>
                        </div>
                    </div>

                </div>
                
            </Tab>
        ) : ""):"";
        const newOrEdit = !!this.state.team ? (<div >

            <Modal show={show} onHide={() => this.handleClose()} >
                    <div className="">
                        <Modal.Header className="" closeButton>
                            <Modal.Title className="">Manage Team {this.state.teamName}</Modal.Title>                          
                        </Modal.Header>
                        <Modal.Body className="">
                            <Tabs defaultActiveKey="name" id="teamEditTabs">
                                <Tab eventKey="name" title="General">
                                    <form id="teamEdit" className="form-horizontal m15">
                                    <div className="form-group row">
                                            <label htmlFor="Name" className="col-sm-2 control-label">Name</label>
                                            <div className="col-sm-10">
                                                <input type="text" className="form-control" name="Name" id="text"
                                                    value={this.state.teamName} onChange={this.onChangeTeamName} />
                                            </div>
                                            <input type="hidden" name="icon" className="item-menu" />
                                        </div>
                                    </form>
                                </Tab>
                            <Tab eventKey="accounts" title="Manage Accounts">
                                <TeamAccounts team={this.state.team} accNum={this.state.account} saveSuccess={this.props.saveSuccess} />
                             
                                </Tab>
                                {premiumEdit}
                                </Tabs>
                        </Modal.Body >
                    <Modal.Footer>

                        <button type="button" className="btn btn-primary" onClick={this.saveSubmit} >Save</button>
                        <button type="button" className="btn btn-light" onClick={this.handleClose} >Cancel</button>

                        <div class="pull-right">
                            <button type="button" className="btn btn-danger" onClick={this.deleteConfirm} >Delete</button>
                        </div>
                        </Modal.Footer >
                        <div className="card ml-2">{msg}</div>
                    </div>                
            </Modal>
         
        </div>
        ) : (<div >

                <Modal show={true} onHide={() => this.handleClose()} >
                    <div className="">
                        <Modal.Header className="" closeButton>
                            <Modal.Title className="">Create New Team</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="">

                            <form id="newEdit" className="form-horizontal">
                                        <div className="form-group row">
                                            <label htmlFor="Name" className="col-sm-2 control-label">Name</label>
                                            <div className="col-sm-10">
                                        <input type="text" className="form-control item-menu" name="Name" id="text" maxLength="50"
                                            value={this.state.teamName} onChange={this.onChangeTeamName} />
                                            </div>
                                            <input type="hidden" name="icon" className="item-menu" />
                                        </div>
                            </form>
                            {msg}

                        </Modal.Body >
                        <Modal.Footer>

                            <input type="submit" value="Create" className="btn btn-primary" onClick={this.saveSubmit} />
                            <button type="button" className="btn btn-light" onClick={() => this.handleClose()} >Cancel</button>

                        </Modal.Footer >
                    </div>
                </Modal>

        </div>
            )
        return (
            <div>
                {newOrEdit}
             
            </div>
        );
    }
}